import { useState } from 'react';

/**
 * Password field with a 👁 toggle on the right. Pass through any standard
 * <input> props. Defaults to autoComplete='current-password'.
 */
export default function PasswordInput({ className = '', autoComplete = 'current-password', ...rest }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        type={show ? 'text' : 'password'}
        autoComplete={autoComplete}
        className={`input pr-10 ${className}`}
        {...rest}
      />
      <button
        type="button"
        onClick={() => setShow(s => !s)}
        tabIndex={-1}
        aria-label={show ? 'Hide password' : 'Show password'}
        className="absolute inset-y-0 right-0 px-3 text-muted hover:text-navy"
      >
        {show ? '🙈' : '👁'}
      </button>
    </div>
  );
}
